<template>
  <div :class="['box-wrapper', viewIndex === 0 ? 'reverse-front' : 'reverse-back']">
    <div class="box" :style="eventBoxStyle">
      <div class="box-header">
        <slot name="perfHeader" />
        <ul v-show="showChangeBtn" class="icon-box-group">
          <li><span class="icon icon-box-reverse" @click="changeWidgetView(viewIndex)"></span></li>
        </ul>
      </div>
      <div class="box-content grid">
        <slot name="perfBody" />
      </div>
      <div v-if="showFooter" class="box-footer" :style="boxFooterStyle">
        <slot name="perfFooter" />
      </div>
    </div>
  </div>
</template>

<script>
import { isNil } from 'lodash';

export default {
  name: 'WPerfWidget',
  props: {
    showChangeBtn: Boolean,
    showFooter: {
      type: Boolean,
      default: true,
    },
    eventlevel: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      viewIndex: 0,
    };
  },
  computed: {
    eventBoxStyle() {
      if (!isNil(this.eventlevel)) {
        return {
          backgroud: '#fff',
          border: `1px solid ${this.eventlevel.eventlevelColorBg}`,
          'box-shadow': `2px 5px 8px -5px ${this.hexToRgba(this.eventlevel.eventlevelColorBg, 0.3)}`,
        };
      }
      return null;
    },
    boxFooterStyle() {
      if (!isNil(this.eventlevel)) {
        return {
          background: `${this.hexToRgba(this.eventlevel.eventlevelColorBg, 0.05)}`,
          'border-top': `1px solid ${this.hexToRgba(this.eventlevel.eventlevelColorBg, 0.3)}`,
        };
      }
      return null;
    },
  },
  methods: {
    /**
     * 상태 컴포넌트 <-> 차트
     * @author kimjy
     * @param  {Integer} viewIndex
     */
    changeWidgetView(viewIndex) {
      this.viewIndex = viewIndex === 0 ? 1 : 0;
      this.$emit('change-widget-view', this.viewIndex);
    },
    hexToRgba(hexType, opacity) {
      let hex = hexType.replace('#', '');
      let value = hex.match(/[a-f\d]/gi);
      if (value.length === 3) {
        hex = value[0] + value[0] + value[1] + value[1] + value[2] + value[2];
        value = hex.match(/[a-f\d]{2}/gi);
      }
      const r = parseInt(value[0] + value[1], 16);
      const g = parseInt(value[2] + value[3], 16);
      const b = parseInt(value[4] + value[5], 16);

      return `rgb(${r}, ${g}, ${b}, ${opacity})`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/PerfWidget.vue